module.exports = __webpack_public_path__ + "media/images/new-year/newyear-2-template-ge-070b0d5f1ff7c8bb2a53d3425bedc4b4.png";